export const SERVER_URL =
	"https://wva86ufoj6.execute-api.us-east-1.amazonaws.com";
export const HTTP_SERVER_URL =
	"https://la6hjo5a62.execute-api.us-east-1.amazonaws.com/dev";
//export const SERVER_URL = "http://localhost:3000";
//export const HTTP_SERVER_URL = "http://localhost:3100";
